import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { LinkCell, StatusCell } from 'core/elements';
import { formatDate } from 'core/utils';
import { PricingProfilePricingType } from 'pricing/enums';
import { getPricingProfilePath } from 'pricing/routes';
import { IPricingProfile } from 'pricing/types';
import { Color } from 'theme/enums';

import { PricingProfileStatus } from './enums';
import { getStatus } from './utils';

export const pricingProfileColumns = {
  statusColumn: {
    colId: 'status',
    headerName: t('headerStatus'),
    field: 'status',
    cellRenderer: StatusCell,
    valueGetter: ({ data }) => getStatus(data),
    cellRendererParams: {
      colorMap: {
        [PricingProfileStatus.ACTIVE]: Color.SUCCESS,
        [PricingProfileStatus.INACTIVE]: Color.NEUTRAL,
      },
    },
    filter: 'agSetColumnFilter',
    filterParams: {
      values: [PricingProfileStatus.ACTIVE, PricingProfileStatus.INACTIVE],
      valueFormatter: ({ value }) =>
        value === PricingProfileStatus.ACTIVE ? t('labelActive') : t('labelInactive'),
    },
    sortable: false,
  },
  corporateUserNameColumn: {
    colId: 'corporateUserName',
    headerName: t('headerCreatedBy'),
    field: 'corporateUserName',
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  agreementIdColumn: {
    colId: 'agreementId',
    headerName: t('headerAgreementId'),
    field: 'agreementId',
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  startDateColumn: {
    colId: 'startDate',
    headerName: t('headerStartDate'),
    field: 'startDate',
    filter: 'agDateColumnFilter',
    valueFormatter: ({ value }) => formatDate(value),
    minWidth: 150,
  },
  endDateColumn: {
    colId: 'endDate',
    headerName: t('headerEndDate'),
    field: 'endDate',
    filter: 'agDateColumnFilter',
    valueFormatter: ({ value }) => formatDate(value),
    minWidth: 150,
  },
  createdAtColumn: {
    colId: 'createdAt',
    headerName: t('headerCreated'),
    field: 'createdAt',
    filter: 'agDateColumnFilter',
    valueFormatter: ({ value }) => formatDate(value),
    minWidth: 150,
  },
  updatedAtColumn: {
    colId: 'updatedAt',
    headerName: t('headerUpdated'),
    field: 'updatedAt',
    filter: 'agDateColumnFilter',
    valueFormatter: ({ value }) => formatDate(value),
    minWidth: 150,
  },
};

export const getColumnDef = ({ type }: { type: PricingProfilePricingType }): ColDef[] => [
  pricingProfileColumns.statusColumn,
  {
    colId: 'name',
    headerName: t('headerProfileName'),
    field: 'name',
    filter: 'agTextColumnFilter',
    cellRenderer: LinkCell,
    cellRendererParams: {
      getPath: (data: IPricingProfile) => getPricingProfilePath(type, data.id),
    },
    cellClass: 'noDecorationCell',
    minWidth: 200,
    maxWidth: 500,
    flex: 1,
  },
  pricingProfileColumns.corporateUserNameColumn,
  pricingProfileColumns.agreementIdColumn,
  pricingProfileColumns.startDateColumn,
  pricingProfileColumns.endDateColumn,
  pricingProfileColumns.createdAtColumn,
  pricingProfileColumns.updatedAtColumn,
];
